import React from "react";
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { Button as AntButton } from "antd";
import { ButtonProps, ButtonType } from "antd/lib/button";
import globalColors from "../styles/globalColors";

type Props = ButtonProps & {
  buttonStyle?: any;
  buttonType?: "primary" | "secondary" | "tertiary";
  disabled?: boolean;
};

const Button: React.FC<Props> = props => {
  const { buttonStyle, buttonType, disabled, ...otherProps } = props;
  let type: ButtonType = "primary";
  if (buttonType === "tertiary") {
    type = "default";
  }

  return (
    <AntButton
      type={type}
      size="large"
      disabled={disabled}
      css={[
        styles.button,
        props.size === "small" && styles.buttonSmall,
        buttonType === "secondary" && styles.buttonSecondary,
        buttonType === "tertiary" && styles.buttonTertiary,
        props.type === "link" && styles.buttonHoverBorder,
        disabled && styles.buttonDisabled,
        buttonStyle
      ]}
      {...otherProps}
    />
  );
};

const styles = {
  button: {
    borderRadius: 5,
    fontWeight: 600,
    fontSize: 14,
    margin: 5,
    padding: "0 29px"
  },
  buttonDisabled: {
    backgroundColor: `${globalColors.inactive} !important`
  },
  buttonSecondary: {
    backgroundColor: globalColors.secondary,
    borderColor: globalColors.secondary,
    ":hover, :focus": {
      backgroundColor: "#90d2d0",
      borderColor: "#90d2d0"
    }
  },
  buttonSmall: {
    padding: "0 13px",
    height: 34
  },
  buttonTertiary: {
    borderColor: globalColors.primary,
    color: globalColors.primary,
    ":hover, :focus": {
      color: "#1b89ab",
      borderColor: "#1b89ab"
    }
  },
  buttonHoverBorder: {
    color: "#1b89ab",
    ":hover": {
      color: "#1b89ab",
      borderColor: "#1b89ab"
    }
  }
};

export default Button;
